import React, { useState } from 'react';
import { TextField } from '@thinkwell/react.polaris'

export default function EmailField(props) {
  const pattern = "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?"

  return (<TextField label={props.label} type={props.type} value={props.value} name={props.name}
    onBlur={props.onBlur} onChange={props.onChange} pattern={pattern} id={props.id}
    validateRef={props.validateRef} required={props.required} />);
}
